// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"5":"081e8965","796":"fd649462"}[chunkId] + ".css";
};